import { OptionSettings } from "@tree-company/tree-query";
import translate from "../locales";
import { Languages } from "@tree-company/collect-js-client";

export function optionsFromTranslations(
  translation_key: string,
  count: number,
): [OptionSettings, ...OptionSettings[]] {
  const options: OptionSettings[] = [];
  for (let index = 0; index < count; index++) {
    options.push({
      value: index + 1,
      label: {
        nl: translate(translation_key, {}, Languages.nl)![index],
        fr: translate(translation_key, {}, Languages.fr)![index],
        de: translate(translation_key, {}, Languages.de)![index],
      },
    });
  }

  return options as [OptionSettings, ...OptionSettings[]];
}

export function translationFromKey(
  key: string | string[],
  interpolations = {},
) {
  return {
    nl: translate(key, interpolations, Languages.nl),
    fr: translate(key, interpolations, Languages.fr),
    de: translate(key, interpolations, Languages.de),
  };
}
